var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { BenefitListItem } from './benefit-list-item';
import { classNames } from '@shapeable/utils';
var cls = classNames('benefit-list');
export var BenefitListDefaultProps = {
  items: []
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n    margin: 0;\n  "], ["\n    padding: 0;\n    margin: 0;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: ", "; \n  "], ["\n    margin-left: ", "; \n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(BenefitListItem)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
export var BenefitList = function (props) {
  var className = props.className,
    children = props.children,
    items = props.items;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, items.map(function (entity) {
    return React.createElement(My.Item, {
      key: entity.id,
      entity: entity
    });
  }), children);
};
BenefitList.defaultProps = BenefitListDefaultProps;
BenefitList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;